/**
 * Gets the size of the scroll bar to be used to correct elements
 * that cause the scrollbar to appear and cause padding issues
 */
let size: number;

export default function scrollbarSize(recalc?: number) {
  if ((!size && size !== 0) || recalc) {
    if (
      typeof window !== 'undefined' &&
      window.document &&
      window.document.createElement
    ) {
      const scrollDiv = document.createElement('div');

      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';

      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}
